import badgeVariables from "@krystal/css/components/badge.css?inline";
import { html, unsafeCSS, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import { version as ekoVersion } from "../../../package.json";
import style from "./environment-label.css?inline";

@customElement("eko-environment-label")
class EnvironmentLabel extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(badgeVariables), unsafeCSS(style)];

  private ekoUIVersion = ekoVersion;

  private ENVIRONMENT_MAP = {
    local: "Local",
    staging: "Staging",
    preproduction: "Preproduction",
    production: "Production",
  } as const;

  @property({ reflect: true }) environment?: "local" | "staging" | "preproduction" | "production";
  @property({ reflect: true, type: String }) gatewayVersion = "";
  @property({ reflect: true, type: String }) upstreamAppVersion = "";

  render() {
    if (!this.environment || !this.ENVIRONMENT_MAP[this.environment]) return null;

    const environmentLabel = this.ENVIRONMENT_MAP[this.environment];

    return html`
      <eko-badge>
        <span class="eko-environment-label">
          <span class="eko-environment-label__content" title="Environment">
            <eko-icon name="globe-01"></eko-icon>
            ${environmentLabel}
          </span>
          <span class="eko-environment-label__content" title="Ekosystem version">
            <eko-icon name="layout-alt-01"></eko-icon>
            v${this.ekoUIVersion}
          </span>
          ${this.gatewayVersion
            ? html`<span class="eko-environment-label__content" title="Gateway version">
                <eko-icon name="log-in-02"></eko-icon>
                v${this.gatewayVersion}
              </span>`
            : nothing}
          ${this.upstreamAppVersion
            ? html`<span class="eko-environment-label__content" title="Upstream app version">
                <eko-icon name="arrow-circle-broken-up"></eko-icon>
                v${this.upstreamAppVersion}
              </span>`
            : nothing}
        </span>
      </eko-badge>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-environment-label": EnvironmentLabel;
  }
}

export default EnvironmentLabel;
